module.exports = __webpack_public_path__ + "img/collection-diamondJewelryDelicateJewels.bd67772.jpg";